/** * @name: ui-list-tag * @Description: 用于列表项 *
type：tag类型(内置primary、info两种) * width：tag宽(String类型，需加上单位) *
height：tag高(String类型，需加上单位) *
fontSize：tag字体大小(String类型，需加上单位) * bgColor：tag背景色(String类型) *
color：tag字体颜色(String类型) * @Author: liulinmei * @Date: 2021-12-8 12:28:46
*/
<template>
  <div
    class="ui-list-tag-container"
    :style="{
      width: containerWidth + 'px',
      height: containerHeight + 'px',
    }"
  >
    <div
      class="ui-list-tag"
      :style="{
        width: tagWidth + 'px',
        height: tagHeight + 'px',
        top: -tagHeight + 'px',
        transform: 'rotate(' + rotateX + 'deg)',
        background: bgColor,
        color: color,
      }"
    >
      <slot>即报即采</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ui-list-tag',
  props: {
    type: {
      type: String,
      default: 'primary',
    },
    bgColor: {
      type: String,
      default: '#0286DF',
    },
    color: {
      type: String,
      default: '#FFFFFF',
    },
  },
  data: function () {
    return {
      tagWidth: '',
      tagHeight: '',
      containerWidth: '',
      containerHeight: '',
      rotateX: '',
    }
  },
  watch: {
    type: {
      handler: function () {
        this.initTag()
      },
      immediate: true,
    },
  },
  methods: {
    initTag() {
      let type = this.type || 'primary'
      let tagContainerData = {
        primary: {
          containerWidth: 45,
          containerHeight: 40,
          tagHeight: 40,
        },
        info: {
          containerWidth: 70,
          containerHeight: 70,
          tagHeight: 20,
        },
      }
      let containerData = tagContainerData[type] || {}
      const { containerWidth, containerHeight, tagHeight } = containerData
      this.containerWidth = containerWidth
      this.containerHeight = containerHeight
      this.tagHeight = tagHeight
      let hypotenuse = this.getTagWidth(containerWidth, containerHeight)
      this.tagWidth = this.type === 'primary' ? hypotenuse + 7 : hypotenuse
      this.rotateX = this.getRotate(containerHeight, hypotenuse)
      console.log('this.rotateX', this.rotateX)
    },
    // 根据矩形的宽高获取tag应该的宽度（矩形的宽高构成的直角三角形斜边的长度）
    getTagWidth(width, height) {
      const bSquare = width ** 2
      const pSquare = height ** 2
      const sum = bSquare + pSquare
      const hypotenuse = Math.sqrt(sum)
      return hypotenuse
    },
    // 获取应该旋转的角度
    getRotate(opposite, hypotenuse) {
      var sinOfAngleX = opposite / hypotenuse // 一直角边/斜边
      let Angle = (Math.asin(sinOfAngleX) * 180) / Math.PI
      return Angle
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-list-tag-container {
  // width: 45px;
  // height: 40px;
  display: inline-block;
  position: relative;
  z-index: -1;
  overflow: hidden;
  // outline: 1px solid red;
}
.ui-list-tag {
  position: absolute;
  left: 0;
  z-index: 100;
  // top: 0;
  // top: -15px;
  // width: 65px;
  // height: 40px;
  // line-height: 58px;
  font-size: 12px;
  background-color: #0286df;
  color: #fff;
  display: flex;
  box-sizing: border-box;
  padding-bottom: 3px;
  align-items: flex-end;
  justify-content: center;
  transform-origin: left bottom;
  // -webkit-transform: rotate(45deg);
  // transform: rotate(45deg);
}
</style>
